// extracted by mini-css-extract-plugin
module.exports = {"logoimg":"Landing_logoimg__3M7co","phoneimg":"Landing_phoneimg__16LOk"};